'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-b2d9610a.js');
var React = require('react');
var index = require('./index-fccd5f88.js');
var Typography = require('./Typography-8468e4cf.js');
var Input = require('./Input-3165014f.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".Autocomplete_module_visuallyHidden__8004675e {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.Autocomplete_module_youtubeVideo__8004675e {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.Autocomplete_module_Autocomplete__8004675e {\n  max-width: 420px;\n  position: relative;\n}\n.Autocomplete_module_Autocomplete__8004675e label {\n  display: block;\n  margin-bottom: 14px;\n}\n\n.Autocomplete_module_Suggestions__8004675e {\n  color: #ffffff;\n  padding: 14px;\n  background-color: #444f6b;\n  border-radius: 0 0 14px 14px;\n  padding: 24px 0 0 0;\n  margin-top: -44px;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n.Autocomplete_module_Suggestions__8004675e a {\n  color: #ffffff;\n  text-decoration: none;\n  border-top: 1px solid #697289;\n  padding: 2px;\n  display: block;\n}\n.Autocomplete_module_Suggestions__8004675e a:hover li {\n  background-color: #292f40;\n  border-radius: 24px;\n}\n.Autocomplete_module_Suggestions__8004675e a:first-child {\n  border-top: none;\n}\n.Autocomplete_module_Suggestions__8004675e li {\n  font-family: var(--font-family-1, \"Karla\", sans-serif);\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 400;\n  padding: 8px 24px;\n  list-style: none;\n}\n\n.Autocomplete_module_SuggestionActive__8004675e {\n  background-color: #363f56;\n  border-radius: 24px;\n}\n\n.Autocomplete_module_NoSuggestions__8004675e {\n  color: #ffffff;\n  padding: 14px;\n  background-color: #444f6b;\n  border-radius: 0 0 14px 14px;\n  padding: 34px 24px 14px 24px;\n  margin-top: -44px;\n  position: absolute;\n  width: 100%;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Organisms/Forms/Autocomplete/Autocomplete.module.scss");
var modules_c8f42129 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"Autocomplete_module_visuallyHidden__8004675e","youtubeVideo":"Autocomplete_module_youtubeVideo__8004675e","Autocomplete":"Autocomplete_module_Autocomplete__8004675e","Suggestions":"Autocomplete_module_Suggestions__8004675e","SuggestionActive":"Autocomplete_module_SuggestionActive__8004675e","NoSuggestions":"Autocomplete_module_NoSuggestions__8004675e"};

var Autocomplete = /*#__PURE__*/function (_Component) {
  _rollupPluginBabelHelpers._inherits(Autocomplete, _Component);
  var _super = _rollupPluginBabelHelpers._createSuper(Autocomplete);
  function Autocomplete(props) {
    var _this;
    _rollupPluginBabelHelpers._classCallCheck(this, Autocomplete);
    _this = _super.call(this, props);
    _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._assertThisInitialized(_this), "onClick", function (e) {
      // Update what our current text should be
      _this.props.onChange({
        target: {
          value: e.currentTarget.innerText
        }
      });

      // Hide suggestions
      _this.setState(_rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, _this.state), {}, {
        showSuggestions: false
      }));

      // Prevent mouse events from hitting underlying components
      e.preventDefault();
    });
    _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$state = _this.state,
        activeSuggestion = _this$state.activeSuggestion,
        filteredSuggestions = _this$state.filteredSuggestions;
      if (e.keyCode === 13) {
        _this.setState({
          activeSuggestion: 0,
          showSuggestions: false,
          userInput: filteredSuggestions[activeSuggestion]
        });
      } else if (e.keyCode === 38) {
        if (activeSuggestion === 0) {
          return;
        }
        _this.setState({
          activeSuggestion: activeSuggestion - 1
        });
      }
      // User pressed the down arrow, increment the index
      else if (e.keyCode === 40) {
        if (activeSuggestion - 1 === filteredSuggestions.length) {
          return;
        }
        _this.setState({
          activeSuggestion: activeSuggestion + 1
        });
      }
    });
    _this.state = {
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: props.value,
      dynamicList: props.dynamicList,
      suggestions: props.suggestions
    };
    return _this;
  }

  /**
   * This listens for when properties change for the Autocompete component.
   * if the value property, or dynamicList|suggestions properties have changed, it will update the filtered things
   * @param {*} props 
   * @param {*} state 
   * @returns null if there is no need to edit the component or a new state
   */
  _rollupPluginBabelHelpers._createClass(Autocomplete, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      this.onChange;
        this.onClick;
        var onKeyDown = this.onKeyDown,
        _this$state2 = this.state,
        activeSuggestion = _this$state2.activeSuggestion,
        filteredSuggestions = _this$state2.filteredSuggestions,
        showSuggestions = _this$state2.showSuggestions,
        userInput = _this$state2.userInput;
      var suggestionsListComponent;
      if (showSuggestions && (userInput || "").length >= 3) {
        if ((filteredSuggestions || []).length > 0) {
          suggestionsListComponent = /*#__PURE__*/React__default["default"].createElement("ul", {
            className: modules_c8f42129.Suggestions
          }, filteredSuggestions.map(function (suggestion, index) {
            var className;

            // Flag the active suggestion with a class
            if (index === activeSuggestion) {
              className = modules_c8f42129.SuggestionActive;
            }
            return /*#__PURE__*/React__default["default"].createElement("a", {
              href: "#",
              key: index
            }, /*#__PURE__*/React__default["default"].createElement("li", {
              className: className,
              key: suggestion,
              onClick: _this2.onClick
            }, suggestion));
          }));
        } else {
          suggestionsListComponent = /*#__PURE__*/React__default["default"].createElement("div", {
            className: modules_c8f42129.NoSuggestions
          }, /*#__PURE__*/React__default["default"].createElement(Typography.Span, {
            color: "#ffffff"
          }, "No suggestions available."));
        }
      }
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: [modules_c8f42129.Autocomplete, this.props.extraClass].join(" ")
      }, /*#__PURE__*/React__default["default"].createElement(Input.Input, {
        iconName: "location--solid",
        showIcon: true,
        label: this.props.label,
        id: this.props.id,
        name: this.props.name,
        onFocus: function onFocus() {
          return _this2.setState(_rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, _this2.state), {}, {
            showSuggestions: true
          }));
        },
        onChange: function onChange(e) {
          // Make sure we have an event
          if (_this2.props.onChange) _this2.props.onChange(e);
        },
        onKeyDown: onKeyDown,
        placeholder: this.props.placeholder || "Placeholder Text",
        hideLabel: this.props.hideLabel,
        type: "text",
        value: userInput,
        autocompleteoff: true
      }), suggestionsListComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var suggestions = props.suggestions,
        dynamicList = props.dynamicList;
      var autoCompleteList = dynamicList || suggestions;
      var stateAutoCompleteList = state.dynamicList || state.suggestions;

      // Check if they have changed
      if (props.value !== state.value || stateAutoCompleteList.join(",") !== autoCompleteList.join(",")) {
        // Get the values that match our value property
        var filteredSuggestions = autoCompleteList.filter(function (suggestion) {
          return suggestion.toLowerCase().indexOf(props.value.toLowerCase()) > -1;
        });
        return _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, state), {}, {
          filteredSuggestions: filteredSuggestions,
          dynamicList: props.dynamicList,
          suggestions: props.suggestions,
          userInput: props.value
        });
      }
      return null;
    }
  }]);
  return Autocomplete;
}(React.Component);
var autoCompletePropTypes = {
  extraClass: index.propTypes.exports.string,
  placeholder: index.propTypes.exports.string,
  label: index.propTypes.exports.string.isRequired,
  hideLabel: index.propTypes.exports.bool,
  id: index.propTypes.exports.string.isRequired,
  name: index.propTypes.exports.string.isRequired
};
Autocomplete.propTypes = autoCompletePropTypes;

exports.Autocomplete = Autocomplete;
